// extracted by mini-css-extract-plugin
export default {"header":"CustomersTableHead_header__vVPb5"};